import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "colorScheme", "dataTestId", "disabled", "error"];
import React, { forwardRef } from 'react';
import { describe } from '@amzn/stencil-react-desc';
import { buildDataTestProps } from "../../utils";
import Ring from "./Ring";
import { RadioHidden, RadioOuter } from "./helperComponents";
import { RadioColorScheme } from "./interfaces";
import { radioPropTypes } from "./propTypes";
import { jsx as ___EmotionJSX } from "@emotion/core";
var Radio = /*#__PURE__*/forwardRef(function (_ref, externalRef) {
  var children = _ref.children,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? RadioColorScheme.Default : _ref$colorScheme,
      dataTestId = _ref.dataTestId,
      disabled = _ref.disabled,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, _excluded);

  var dataTestProps = buildDataTestProps({
    dataTestComponent: 'StencilReactRadio',
    dataTestId: dataTestId
  });
  var inputDataTestProps = buildDataTestProps({
    dataTestComponent: 'StencilReactRadioInput',
    dataTestId: dataTestId
  });
  return ___EmotionJSX(RadioOuter, _extends({
    disabled: disabled
  }, dataTestProps), ___EmotionJSX(RadioHidden, _extends({}, inputDataTestProps, props, {
    "aria-invalid": error,
    className: "stencilRadioHidden",
    disabled: disabled,
    type: "radio",
    ref: externalRef
  })), ___EmotionJSX(Ring, {
    colorScheme: colorScheme,
    disabled: disabled,
    error: error
  }));
});
var RadioWithDocs = describe(Radio).description('Form element for choosing one item from a set of options.');
RadioWithDocs.propTypes = radioPropTypes;
RadioWithDocs.displayName = 'Radio';
export default RadioWithDocs;